<template>
<div class="page">
    <div class="page__bd" style="background-color: #f1f1f1;">
        <div v-for="(sealOut, index) in listInfo" :class="[{'gap': index != 0}, 'weui-form-preview']"
            @click.stop.prevent="detail(sealOut.id, sealOut.orderId, sealOut.taskId, sealOut.taskName)">
            <div class="weui-form-preview__hd">
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">标题</label>
                    <em class="weui-form-preview__value">{{sealOut.title}}</em>
                </div>
            </div>
            <div class="weui-form-preview__bd">
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">创建时间</label>
                    <span class="weui-form-preview__value">{{sealOut.createTime}}</span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">状态</label>
                    <span class="weui-form-preview__value">{{getSealOutState(sealOut)}}</span>
                </div>
            </div>
            <div class="weui-form-preview__ft">
                <a @click.stop.prevent="detail(sealOut.id, sealOut.orderId, sealOut.taskId, sealOut.taskName)" class="weui-form-preview__btn weui-form-preview__btn_primary">查看</a>
            </div>
        </div>
    </div>
</div>
</template>
<script>
  import { mapActions } from 'vuex'
  export default {
    props: ['btnname', 'listInfo', 'viewType'],
    data () {
      return {
        hellow: '123'
      }
    },
    methods: {
      ...mapActions([
        'resetSealOutDetail'
      ]),
      detail (sealOutId, orderId, taskId, taskName) {
        let queryData = {
          orderId: orderId,
          selected: this.$route.query.selected,
          showNavbar: this.$route.query.showNavbar
        }

        if (taskId && taskId.length > 0) {
          queryData['taskId'] = taskId
        }

        if (taskName && taskName.length > 0) {
          queryData['taskName'] = taskName
        }

        this.$router.push({
          path: '/sealOut/' + this.viewType + '/' + sealOutId,
          query: queryData
        })
      },
      getSealOutState (contract) {
        if (contract.state === 50) {
          return '已删除'
        } else if (contract.displayName) {
          return contract.displayName
        } else if (contract.state === 100) {
          return '待提交申请'
        } else if (contract.state === 900) {
          return '已归还'
        }
        return ''
      }
    },
    mounted: function () {
      this.resetSealOutDetail()
    }
  }
</script>
<style>
  .gap{
    margin-top: 5px
  }
</style>



// WEBPACK FOOTER //
// listSealOut.vue?4980970a